// Re-export SharedVideoPlayer as TeamStatsVideoPlayer for backwards compatibility
import SharedVideoPlayer from '../../../components/SharedVideoPlayer';

const TeamStatsVideoPlayer = (props) => <SharedVideoPlayer {...props} />;

export default TeamStatsVideoPlayer;
